var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlarm = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9421_37519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27907 1.87958C4.67947 1.66628 4.83114 1.16879 4.61785 0.768395C4.40455 0.368002 3.90706 0.216327 3.50666 0.429622C2.37638 1.03174 1.36779 1.83861 0.532253 2.80915C0.236269 3.15296 0.275038 3.67161 0.618846 3.9676C0.962653 4.26357 1.48131 4.2248 1.77729 3.881C2.48006 3.06467 3.32838 2.38602 4.27907 1.87958Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4933 0.429622C12.0929 0.216327 11.5955 0.368002 11.3822 0.768395C11.1689 1.16879 11.3206 1.66628 11.721 1.87958C12.6716 2.38602 13.5199 3.06467 14.2227 3.881C14.5188 4.2248 15.0374 4.26357 15.3811 3.9676C15.7249 3.67161 15.7637 3.15296 15.4678 2.80915C14.6322 1.83861 13.6236 1.03174 12.4933 0.429622Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5714 9.09508C14.5714 12.7244 11.6293 15.6665 8.00001 15.6665C4.37071 15.6665 1.42858 12.7244 1.42858 9.09508C1.42858 5.46577 4.37071 2.52365 8.00001 2.52365C11.6293 2.52365 14.5714 5.46577 14.5714 9.09508ZM6.13332 6.23303C5.76513 6.23303 5.46665 6.53151 5.46665 6.89969C5.46664 7.26788 5.76512 7.56636 6.13331 7.56637L8.44733 7.56638L5.62023 10.974C5.45523 11.1729 5.42002 11.4492 5.52989 11.6831C5.63975 11.917 5.87535 12.0663 6.13376 12.0663L9.86665 12.0664C10.2348 12.0664 10.5333 11.7679 10.5333 11.3997C10.5333 11.0315 10.2348 10.733 9.86665 10.733L7.55262 10.733L10.3797 7.32539C10.5447 7.12651 10.5799 6.85019 10.4701 6.6163C10.3602 6.3824 10.1251 6.23306 9.86665 6.23306L6.13332 6.23303Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9421_37519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlarm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Alarm.02634a34a594202ca39394e56963ff78.svg";